import React, { useEffect, useState } from 'react';
import "./Documents.css";
import { firestore, auth } from "../../firebase/firebaseConfig";
import { setDoc, doc, onSnapshot } from '@firebase/firestore';
import { onAuthStateChanged } from "firebase/auth";
import { Button, Input } from 'antd';

function Documents () {
    let [ documents, setDocuments ] = useState( [] );

    async function onload () {
        onSnapshot( doc( firestore, "GlobalConfigurations/DocumentType" ), ( snapshot ) => {
            setDocuments( [ ...snapshot.data().documents ] );
        } );

        document.querySelector( ".sending-loader" ).style.display = "none";
    }

    useEffect( () => {
        document.querySelector( ".sending-loader" ).style.display = "flex";
        document.querySelectorAll( ".ant-menu-item" )[ 9 ].click();
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onload();
            } else {
                window.location.href = "/login";
            }
        } );
    }, [] );

    return (
        <div className='making-container'>
            <form onSubmit={async event => {
                event.preventDefault();
                document.querySelector( ".sending-loader" ).style.display = "flex";
                let array = documents;
                array.push( event.target.document_name.value );

                await setDoc( doc( firestore, "GlobalConfigurations", "DocumentType" ), {
                    documents: documents
                } )

                event.target.reset();
                document.querySelector( ".sending-loader" ).style.display = "none";
            }} className="making-container-top-container">
                <Input style={{ width: "180px" }} type="text" placeholder='Enter Document' className='document-name' name='document_name' required />
                <Button htmlType='submit'>Add Document</Button>
            </form>
            <div className="all-make-city-container" style={{ width: "95%" }}>
                Documents
            </div>
            <div className='all-make-entries-container'>
                {documents.map( ( element, index ) => (
                    <div style={{ alignItems: "center", width: "100%", justifyContent: "space-between" }} className='all-make-entry-container'>
                        <h5 style={{ color: "white" }}>{element}</h5>
                        <Button danger onClick={async event => {
                            document.querySelector( ".sending-loader" ).style.display = "flex";
                            documents.splice( index, 1 );

                            await setDoc( doc( firestore, "GlobalConfigurations", "DocumentType" ), {
                                documents: documents
                            } )
                            document.querySelector( ".sending-loader" ).style.display = "none";
                        }}>Delete Document</Button>
                    </div>
                ) )}
            </div>
        </div>
    )
}

export default Documents